module.exports = __webpack_public_path__ + "img/496DBA_94C9F2_72A7E2_84B4EC-256px.1bfed348.png";